// Pattern distinguishes between /trail/new and trail/new-zealand/...
const matchRegex = /^\/(de|es|fr)\/(trail\/new|trail|parks)($|\/.*|\?.*)/;
// May omit a mapping if the translated is the same as the English
const conversions = {
  'de': {
    'trail': 'route',
    'trail/new': 'route/neue'
  },
  'es': {
    'trail': 'ruta',
    'trail/new': 'ruta/nueva',
    'parks': 'parques'
  },
  'fr': {
    'trail': 'randonnee',
    'trail/new': 'randonnee/nouvelle',
    'parks': 'parcs'
  }
};

const localizeUrlComponents = urlWithShortLanguagePrefix => {
  const match = urlWithShortLanguagePrefix.match(matchRegex);
  if (match && conversions[match[1]][match[2]]) {
    return `/${match[1]}/${conversions[match[1]][match[2]]}${match[3]}`;
  } else {
    return urlWithShortLanguagePrefix;
  }
};

const LanguageSupportUtil = {
  wrapUrlSafe(url, languageRegionCode) {
    if (languageRegionCode) {
      const code = languageRegionCode.split('-')[0];
      if (code.toLowerCase() !== 'en') {
        return localizeUrlComponents(`/${code}${url}`);
      }
      return url;
    }
    if (typeof window === 'undefined') {
      var window = this;
    }
    if (window && window.checkLinkAndAppendLanguage) {
      return localizeUrlComponents(window.checkLinkAndAppendLanguage(url));
    }
    return url;
  },
  findRecordFieldWithLocale(record, field, locale = 'en-US') {
    const key = `${field}_${locale.substring(0, 2)}`;
    if (record[key]) {
      return record[key];
    }
    return record[field];
  }
};

export { LanguageSupportUtil };
if (process.env.NODE_ENV === "test") {
  exports.localizeUrlComponents = localizeUrlComponents;
}
